<template>
    <el-dialog
      v-model="downloadHistoryVisible"
      title="下载记录"
      :width="isMobile ? '95%' : '600px'"
      :fullscreen="isMobile && isSmallScreen"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="download-history-dialog"
    >
      <div class="download-history-container">
        <div v-for="(record, index) in downloadRecords" :key="index" class="download-record">
          <div class="download-icon">
            <img src="@/assets/images/PDF.png" alt="下载">
          </div>
          <div class="download-info">
            <span class="download-name">{{ record.opContent }}</span>
          </div>
          <div class="download-date">{{ record.opTime }}</div>
        </div>
      </div>
      
      <div class="download-pagination">
        <el-pagination
          :currentPage="currentPage"
          :pagerCount="isMobile ? 5 : 7"
          :page-size="10"
          layout="prev, pager, next"
          :total="total"
          @currentChange="handlePageChange"
        />
      </div>
    </el-dialog>
</template>
<script>
import resultsService from '@/service/results.service.js'

export default {
  name: 'recordList',
  components: {
  },
  computed: {
    // Check if device is mobile
    isMobile() {
      return this.windowWidth < 768
    },
    // Check if screen is very small
    isSmallScreen() {
      return this.windowWidth < 480
    }
  },
  data() {
    return {
      downloadHistoryVisible: false,
      currentPage: 1,
      total: 0,
      windowWidth: window.innerWidth,
      downloadRecords: []
    }
  },
  methods: {
    // Existing methods for download history
    showDownloadHistory() {
      let data = {
        pn: this.currentPage,
        ps: 10,
        userCode: localStorage.getItem('userCode'),
        channelCodes: 'home'
      }
      resultsService.getDownloadHistory(data).then(res => {
        if(res.data.code == '0000'){
          this.downloadRecords = res.data.data.list;
          console.log(res.data.data.total);
          this.total = res.data.data.total;
        }
      })
      this.downloadHistoryVisible = true
    },
    
    handlePageChange(page) {
      this.currentPage = page
      this.showDownloadHistory()
    },
  },
}
</script>

<style scoped>

/* Download History Modal Styles */
.download-history-container {
  padding: 10px 0;
}

.download-record {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.download-icon {
  width: 40px;
  height: 40px;
  background-color: #f5f5f5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: #ff6b35;
  flex-shrink: 0;
}

.download-icon i {
  font-size: 20px;
}

.download-info {
  flex: 1;
  min-width: 0; /* Prevents flex item from overflowing */
}

.download-name {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.download-date {
  font-size: 13px;
  color: #999;
  margin-left: 15px;
  white-space: nowrap;
  flex-shrink: 0;
}

.download-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style> 